"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledSubtext = exports.StyledHeader = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _excluded = ["name", "originalName", "area"];
var HotelRoomName = function HotelRoomName(_ref) {
  var name = _ref.name,
    originalName = _ref.originalName,
    area = _ref.area,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var disabled = rest.disabled,
    className = rest.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    disabled: disabled,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledHeader, null, "".concat(name).concat(area ? " \xB7 ".concat(area).concat(t('hotel.room.area')) : '')), originalName && /*#__PURE__*/_react["default"].createElement(StyledSubtext, null, originalName));
};
var StyledHeader = exports.StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomName__StyledHeader",
  componentId: "sc-y5gb65-0"
})(["color:var(--black);font-size:18px;font-style:normal;font-weight:500;;"]);
var StyledSubtext = exports.StyledSubtext = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomName__StyledSubtext",
  componentId: "sc-y5gb65-1"
})(["", " color:", ";"], function (props) {
  return props.theme.typography.text3;
}, function (props) {
  return props.theme.colors.greyLight;
});
HotelRoomName.propTypes = {
  name: _propTypes["default"].string.isRequired,
  originalName: _propTypes["default"].string,
  area: _propTypes["default"].number
};
HotelRoomName.defaultProps = {
  originalName: null,
  area: null
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelRoomName);